import React, { createContext, useContext, useState } from 'react';

const MatchProbabilitiesSearchContext = createContext();

export const MatchProbabilitiesSearchProvider = ({ children }) => {
  const [searchInput, setSearchInput] = useState('');

  return <MatchProbabilitiesSearchContext.Provider value={{ searchInput, setSearchInput }}>{children}</MatchProbabilitiesSearchContext.Provider>;
};

export const useMatchProbabilitiesSearch = () => useContext(MatchProbabilitiesSearchContext);